module.exports = __webpack_public_path__ + "./img/arrow-up.svg";